import type { PrinterEngine, PrinterTransport } from '@techgitter/contracts';

/**
 * Front-end mirror of the backend's engine/transport rules
 * (core/services/printer_config_service.py). Kept here so the edit dialog
 * and the list page agree on labels and on how a null transport is derived.
 */

export const ENGINE_OPTIONS: { value: PrinterEngine; label: string }[] = [
  { value: 'brother-raster', label: 'Brother raster' },
  { value: 'star-text', label: 'Star text' },
  { value: 'pdf-spooler', label: 'PDF spooler' },
  { value: 'zebra-zpl', label: 'Zebra ZPL' },
];

export const TRANSPORT_OPTIONS: { value: PrinterTransport; label: string }[] = [
  { value: 'tcp9100', label: 'tcp9100' },
  { value: 'spooler', label: 'spooler' },
];

const ENGINE_DEFAULT_TRANSPORT: Record<PrinterEngine, PrinterTransport> = {
  'brother-raster': 'tcp9100',
  'star-text': 'tcp9100',
  'pdf-spooler': 'spooler',
  'zebra-zpl': 'tcp9100',
};

/**
 * The effective transport: an explicit override, else derived from the
 * engine. Returns null when neither is known (an unselected engine).
 */
export function resolveTransport(
  engine: PrinterEngine | null,
  transport: PrinterTransport | null,
): PrinterTransport | null {
  if (transport) return transport;
  if (engine) return ENGINE_DEFAULT_TRANSPORT[engine] ?? null;
  return null;
}
